// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1X9-v","dragIcon":"SortableItem_dragIcon__1sPo6","disabled":"SortableItem_disabled__LtplE"};